import useTranslation from 'next-translate/useTranslation'
import { Rule } from 'rc-field-form/lib/interface'

type TOptions = {
  name: string;
  validate?: (value: any) => boolean;
}


export const useRequiredValidationRules = (opts: TOptions): Rule[] => {
  const { t } = useTranslation();

  return [
    ...(opts.validate ? [{
      validator: (rule, value) => {
        const valid = opts.validate!(value);
        if (valid) return Promise.resolve();
        return Promise.reject(t('validation:required', { field: opts.name }));
      }
    }] : [{
      required: true,
      message: t('validation:required', { field: opts.name })
    }]) as Rule[],
  ]
}